import FullPageLoader from "@Components/FullPageLoader";
import loadData from "./data";
import loadable from "@loadable/component";
import NotFound from "@Pages/NotFound";
import ErrorBoundary from "@Components/ErrorBoundary";
import useBookFormPage from "./useBookFormPage";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";

const BookForm = loadable(() => import("./BookForm"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isLoading, showFullPageLoader } = useBookFormPage(props);

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (showFullPageLoader || typeof window === "undefined") {
    return <FullPageLoader showAnimated />;
  }
  return (
    <ErrorBoundary>
      <BookForm {...props} isLoading={isLoading} />
      <AmberCopilotWrapper />
    </ErrorBoundary>
  );
};

export { BookForm as PreFetchBookForm };
export { loadData };
